export const RESERVATION_CHANGE_REASONS = ['Illness - client', 'Illness - instructor', 'Schedule Conflict - client', 'Schedule Conflict - instructor', "Weather - Outside of instructor's minimums", "Weather - Outside of client's minimums", 'Aircraft maintenance', 'other'];

export const hoursUntilReservationStart = (reservation, now = Date.now()) => {
  const date = String(reservation?.startDate || '').split('T')[0];
  const time = String(reservation?.startTime ?? '');
  const clock = time.includes(':') ? time : `${String(Math.floor(Number(time) / 100)).padStart(2, '0')}:${String(Number(time) % 100).padStart(2, '0')}`;
  return (new Date(`${date}T${clock}`) - Number(now)) / 3600000;
};

export const requiresReservationReason = (reservation, now = Date.now()) => {
  const hours = hoursUntilReservationStart(reservation, now);
  return hours >= 0 && hours <= 28;
};

export const canCancelReservationAtShortNotice = (reservation, user, now = Date.now()) => {
  const type = String(reservation?.type || '').trim().toLowerCase();
  const hours = hoursUntilReservationStart(reservation, now);
  if (!['flight training', 'flight lesson'].includes(type) || !(hours >= 0 && hours <= 24)) return true;
  return ['admin', 'superuser', 'instructor'].includes(user?.orgRole)
    || Number(user?.roleId) === 3
    || String(user?.role || '').toLowerCase() === 'instructor'
    || [true, 1, '1', 'true'].includes(user?.isInstructor)
    || (user?.id != null && String(user.id) === String(reservation?.userIdInstructor));
};